<template>
<!-- task -->
<form id="task-form">
	<div class="w-full grid justify-items-center">
		<!-- Todo panel -->
		<panel :title="$t('eny.to_do')" addclass="mt-4 w-full max-w-[1300px] !pb-8">
			<div class="text-color-text font-semibold text-3xl rounded-lg flex items-center mt-4 flex-col">
				<div class="w-full flex space-x-4">
					<ejs-textbox :multiline="true" :rows="3" name="text" floatLabelType="Auto" :placeholder="$t('eny.cembra').toUpperCase()" v-model:value="todo.text1" cssClass="flex-1"></ejs-textbox>
					<ejs-textbox :multiline="true" :rows="3" name="text" floatLabelType="Auto" :placeholder="$t('eny.banknow').toUpperCase()" v-model:value="todo.text2" cssClass="flex-1"></ejs-textbox>
					<ejs-textbox :multiline="true" :rows="3" name="text" floatLabelType="Auto" :placeholder="$t('eny.eny_card').toUpperCase()" v-model:value="todo.text3" cssClass="flex-1"></ejs-textbox>
				</div>
				<div class="w-full pt-4">
					<ejs-textbox :multiline="true" :rows="3" name="text" floatLabelType="Auto" :placeholder="$t('eny.missing_documents').toUpperCase()" v-model:value="todo.text4" cssClass="w-full"></ejs-textbox>
				</div>
				<!-- save button -->
				<div class="w-full pt-5 flex flex-row justify-center">
					<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="onSaveTodo" :disabled="loading">{{$t('eny.save')}}</button>
				</div>
			</div>
		</panel>
		<panel :title="$t('eny.action')" addclass="mt-4 w-full max-w-[1300px]">
			<div class="w-full grid grid-flow-col items-justify-center grid-cols-1 mt-8">
				<ejs-combobox name='action' :dataSource='actions' :fields='fields' floatLabelType="Auto" placeholder="" :showClearButton="false" :allowCustom="false" v-model:value="action_loc.action"></ejs-combobox>
			</div>
		</panel>
		<panel :title="$t('eny.task')" addclass="mt-4 w-full max-w-[1300px]">
			<div class="text-color-text font-semibold text-3xl rounded-lg flex items-center mt-4 flex-col">
				<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2">
					<div class='px-4'>{{ $t('eny.text') }}</div>
					<div class="items-center mx-4 col-start-3 col-span-3">
						<ejs-textbox :multiline="true" name="task_text" floatLabelType="Auto" placeholder="" v-model:value="task_loc.text"></ejs-textbox>
					</div>
				</div>
				<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2">
					<div class='px-4'>{{ $t('eny.date') }}</div>
					<div class="items-center mx-4 col-start-3 col-span-3">
						<validation><ejs-datepicker name='task_date' floatLabelType="Auto" placeholder="" :format="$t('eny.date_format')" :open='onOpen' v-model:value="task_loc.date"></ejs-datepicker></validation>
					</div>
				</div>
				<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2">
					<div class='px-4'>{{ $t('eny.responsible') }}</div>
					<div class="items-center mx-4 col-start-3 col-span-3">
						<!-- Hier sollen alle eny Mitarbeiter auswählbar sein -->
						<ejs-combobox name='task_responsible' :dataSource='admins' :fields='fields' floatLabelType="Auto" placeholder="" :showClearButton="true" :allowCustom="false" v-model:value="task_loc.responsible"></ejs-combobox>
					</div>
				</div>
			</div>
		</panel>
		<!-- save button -->
		<div class="w-full md:px-20 pt-5 flex flex-row justify-center">
			<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="onSave" :disabled="loading">{{$t('eny.save')}}</button>
		</div>
	</div>
</form>
<!-- task history-->
<history :user_id="sel_user_id"></history>
<!-- tickets-->
<tickets filter=2 canEdit=''></tickets>
<!-- Documents -->
<dashboard-documents allowDelete="true"></dashboard-documents>
</template>

<script>
import { MaskedTextBoxComponent, TextBoxComponent, FormValidator } from '@syncfusion/ej2-vue-inputs';
import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import Validation from "../../Base/Validation.vue";
import Panel from "../../Base/Panel.vue";
import DashboardTaskHistory from './DashboardTaskHistory.vue';
import DashboardDocuments from "./DashboardDocuments.vue";
import TicketTable from "../Tickets/TicketTable.vue";
import useUtils from '../../hooks/useUtils';
import { mapGetters } from 'vuex';

export default {
	name: "DashboardTask",
	components: {
		'panel': Panel,
		'ejs-maskedtextbox': MaskedTextBoxComponent,
		'ejs-combobox': DropDownListComponent,
		'ejs-datepicker': DatePickerComponent,
		'ejs-textbox': TextBoxComponent,
		'validation': Validation,
		'history': DashboardTaskHistory,
		'dashboard-documents': DashboardDocuments,
		'tickets': TicketTable,
	},
	setup() {
		const { sleep, doCopy, isEmptyObj, isFormattedDateValid, localTimeWithOffset } = useUtils();
		return {
			sleep,
			doCopy,
			isEmptyObj,
			isFormattedDateValid,
			localTimeWithOffset
		}
	},
	data() {
		return {
			actions: JSON.parse(this.$t('eny.actions')),
			fields: { text: 'label', value: 'value' },
			sel_user_id: 0,
			task_loc: {}
		}
	},
	created() {
		this.sel_user_id = this.user.id ?? 0;
		if (this.isEmptyObj(this.admins)) {
			this.$store.dispatch('user/admins');
		}
		const user = this.$route.params.uid;
		if (user && this.user.id != user) {
			this.$store.dispatch('customer/loadTask', user)
			this.$store.dispatch('customer/loadTaskHistory', user);
		}
		if (this.$route.params.uid && this.request.user_id != this.$route.params.uid) {
			this.$store.dispatch('customer/loadWholeData', this.$route.params.uid);
		}
	},
	mounted() {
		const options = {
			rules: {
				task_date: {
					required: false,
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')]
				},
			},
			customPlacement: this.showValidationError,
		};
		this.formObject = new FormValidator("#task-form", options);
	},
	computed: {
		...mapGetters('customer', ['request', 'task', 'user', 'todo', 'loading']),
		...mapGetters('user', ['admins']),
		action_loc() {
			if (!this.task.action) {
				this.task.action = 1
			}
			return this.task;
		},
	},
	methods: {
		onOpen: function(e) {
			this.sleep(10).then(function() {
				e.popup.offsetX = e.popup.relateTo.clientWidth - e.popup.properties.content.clientWidth;
			});
		},
		onSave() {
			const user = this.sel_user_id
			if (this.formObject.validate() && user && this.task_loc.text) {
				let task_data = {
					action: this.action_loc.action,
					text: this.task_loc.text,
					date: this.localTimeWithOffset(this.task_loc.date),
					responsible: this.task_loc.responsible,
					user_id: user
				}
				this.sel_user_id = 0
				this.task_loc.text = ''
				this.task_loc.date = ''
				this.task_loc.responsible = null
				this.$store.dispatch('customer/saveTask', task_data);
			}
		},
		onSaveTodo() {
			this.$store.dispatch('customer/saveTodo', this.todo)
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
		},
		isValidDate(input) {
			return this.isFormattedDateValid(input.value, this.$t('eny.moment_date_format'));
		},
	},
	watch: {
		user(value) {
			this.sel_user_id = (value && value.id) ? value.id : 0;
		},
	}
};
</script>
<style>
.e-float-input, .e-float-input.e-control-wrapper{
	margin-top: 1px;
}
</style>
